import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const LocationDetailsSkeleton = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1.5}>
        {/* Origen */}
        <Box>
          <Skeleton variant="text" width="15%" height={28} sx={{ mb: 0.5 }} />
          <Stack spacing={0.5}>
            <Skeleton variant="text" width="75%" height={18} />
            <Skeleton variant="text" width="55%" height={18} />
            <Skeleton variant="text" width="65%" height={18} />
          </Stack>
        </Box>

        {/* Destino */}
        <Box>
          <Skeleton variant="text" width="15%" height={28} sx={{ mb: 0.5 }} />
          <Stack spacing={0.5}>
            <Skeleton variant="text" width="75%" height={18} />
            <Skeleton variant="text" width="55%" height={18} />
            <Skeleton variant="text" width="65%" height={18} />
          </Stack>
        </Box>

        {/* Actividades / Productos */}
        <Box>
          <Skeleton variant="text" width="25%" height={28} sx={{ mb: 0.5 }} />
          <Stack spacing={0.5}>
            <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default LocationDetailsSkeleton;
